import classnames from "classnames";
import classes from "../../../styles/Resources.module.scss";
import Banner from "../../../components/common/Banner/Banner";
import BannerType from "../../../global/banner-type";
import resources from "../../../assets/images/resources.png";
import { caseStudy } from "../../../global/constant";
import { nanoid } from "nanoid";
import CascadingList from "../../../components/core/CascadingList/CascadingList";
import { useEffect, useState } from "react";

const CaseStudy = () => {
  return (
    <>
      <div className={classnames(classes.main_content)}>
        <div className={classnames(classes.bannerSection)}>
          <Banner
            type={BannerType.SINGLE_IMAGE_BANNER}
            title="Case Studies"
            description="In-depth analysis of a particular stituation,event & proposing solutions."
            image={resources}
            maxWidth={214}
            className={classes.containerWidth}
          />
        </div>
        <div className={classes.contentSection}>
          <div
            className={classnames(classes.grid_box, classes.caseStudy_box)}
            style={{ flex: 1 }}
          >
            {caseStudy.map((casestudy, index) => {
              let backgroundColor;
              if (index % 3 === 0) {
                backgroundColor = "#FACC15";
              } else if (index % 3 === 1) {
                backgroundColor = "#B2D0FF";
              } else {
                backgroundColor = "#60A5FA";
              }
              return (
                <Banner
                  type={BannerType.CASE_STUDY}
                  {...casestudy}
                  key={nanoid()}
                  width={"100%"}
                  buttonLabel="Download"
                  backgroundColor={backgroundColor}
                />
              );
            })}
          </div>
          <div>
            <CascadingList data={caseStudy} title="CONTENTS" />
          </div>
        </div>
      </div>
    </>
  );
};
export default CaseStudy;
